import { render, staticRenderFns } from "./BirthdaysModal.vue?vue&type=template&id=f6ef9606&scoped=true&"
import script from "./BirthdaysModal.vue?vue&type=script&lang=js&"
export * from "./BirthdaysModal.vue?vue&type=script&lang=js&"
import style0 from "./BirthdaysModal.vue?vue&type=style&index=0&id=f6ef9606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ef9606",
  null
  
)

export default component.exports